import { render, staticRenderFns } from "./AdminAdd.vue?vue&type=template&id=065210be"
import script from "./AdminAdd.vue?vue&type=script&lang=js"
export * from "./AdminAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports